module.exports = __webpack_public_path__ + "static/media/memories_8.9cd2c1f3.jpg";